import { useContext, useEffect, useState } from 'react';
import axios, { AxiosInstance } from 'axios';
import { BookingStyles } from '../interfaces/bookingStyles.interface';
import ErrorLoggingService from './errorlogging.service';
import getUrlSearchParam from '../helpers/urlSearchParams.helper';
import { getLanguage } from '../../i18n';
import { CacheDataContext } from '../../context/cacheContext/cacheContext';

const useFetchBookingStyles = <T>(): any => {
  const [styleConfig, setStyleData] = useState<BookingStyles>(null!);
  const { getUrlParam } = useContext(CacheDataContext);
  const brand: string | null = getUrlParam('brand');
  const api: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_AGENT,
  });
  useEffect((): void => {
    if (!brand) {
      return;
    }
    const fetchData = async (): Promise<void> => {
      const errorService = ErrorLoggingService.getInstance();
      try {
        const selectedBrand = brand ? brand.toLowerCase() : 'fctg';
        const timestamp = Date.now();
        const configUrl = `/config/config_styles_${selectedBrand}.json?timestamp=${timestamp}`;
        const response = await fetch(configUrl);
        if (!response.ok) {
          throw new Error(`Error fetching data: ${response.statusText}`);
        }
        const fetchedData = await response.json();
        setStyleData(fetchedData[0]);
      } catch (errorResponse) {
        errorService.log('Error loading styles');
      }
    };
    fetchData();
  }, []);

  return { styleConfig };
};

export default useFetchBookingStyles;
